import axios from "./config";
import { API } from "./api";

export const accountLookupFetch = async (body) => {
  const { accountNumber, accountName, parentStoreCcn, parentNumber, isIpaAccount } = body;

  const searchParams = new URLSearchParams(
    _.pickBy(
      {
        name: accountName,
        number: accountNumber,
        parentStoreCcn,
      },
      _.identity,
    ),
  );

  const res = await axios(`/fc-site-repo/accounts?${searchParams}`);
  return res.data.map((account) => ({
    ...account,
    accountNumber: account.customerNumber,
    parentStoreCcn,
    phoneNumber: account.phone1 ?? account.phone2 ?? account.cellPhone,
    street: account.address1,
    customerName: account.contactName,
  }));
};
